import { Dialog, DialogContent, DialogTitle } from "@workspace/frontend-ui";
import type { FC, PropsWithChildren, RefObject } from "react";

type Props = PropsWithChildren<{
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  title: string;
  inputRef: RefObject<HTMLInputElement | null>;
}>;

const SearchModalShell: FC<Props> = ({
  open,
  onOpenChange,
  title,
  inputRef,
  children,
}) => {
  const onOpenAutoFocus = (event: Event) => {
    event.preventDefault();
    if (navigator.maxTouchPoints === 0) inputRef.current?.focus();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        className="flex flex-col gap-3 px-4 pt-4 md:px-6 md:pt-6! pb-0 max-md:h-full sm:max-w-none max-md:rounded-none max-md:max-w-none md:rounded-3xl md:max-w-[85vw] lg:max-w-[85vw] md:h-[56vw] xl:max-w-[1096px] xl:h-[640px] [@media(min-width:1440px)]:max-w-[1096px] [@media(min-width:1440px)]:h-[740px] 2xl:h-[794px] md:max-h-[90vh] bg-background"
        aria-describedby={undefined}
        onOpenAutoFocus={onOpenAutoFocus}
        data-testid="search-overlay"
      >
        <DialogTitle className="sr-only">{title}</DialogTitle>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default SearchModalShell;
